import type { ComponentProps } from 'react'
import { MultiSelect } from 'react-native-element-dropdown'
import type { MultiSelectProps } from 'react-native-element-dropdown/lib/typescript/components/MultiSelect/model'
import { withUnistyles } from 'react-native-unistyles'

import type { Theme } from '@/styles/theme'

const BaseMultiSelect = withUnistyles(MultiSelect)

type BaseMultiSelectProps = ComponentProps<typeof BaseMultiSelect>

type UniMultiSelectProps<T> = MultiSelectProps<T> & {
  getThemeProps?: (theme: Theme) => Partial<MultiSelectProps<T>>
}

const UniMultiSelect = <T,>({
  getThemeProps,
  ...rest
}: UniMultiSelectProps<T>) => {
  return (
    <BaseMultiSelect
      {...(rest as unknown as BaseMultiSelectProps)}
      uniProps={
        getThemeProps
          ? (((theme: Theme) =>
              getThemeProps(theme)) as BaseMultiSelectProps['uniProps'])
          : undefined
      }
    />
  )
}

export default UniMultiSelect
